import {useEffect, useState} from 'react'
import {CheckboxStepPicture} from '../../components/NewComponents/CheckboxStepPicture'
import {createCatalog} from '../../services/createCatalog.service'
import {getGrocersImg, getGrocersBrand} from './helpers'
import {createNewCatalogs} from '../../services/catalog.service'
import {Spinner} from '../ui'
import {useNavigate} from 'react-router-dom'
import { LoaderNew } from '../../components/LoaderNew'

const TYPE_CATALOG = {
	1: 'SELL-IN',
	2: 'SELL-OUT',
}

export const CreateCatalog = ({setCreateCatalogState}) => {
	const [step, setStep] = useState(1)
	const [tag, settag] = useState(false)
	const [nameCatalog, setNameCatalog] = useState('')
	const [warning, setwarning] = useState(null)
	const [slidingValue, setslidingValue] = useState(0)
	const [grocers, setGrocers] = useState([])
	const [grocersSelected, setGrocersSelected] = useState(null)
	const [typeCatalogSelected, setTypeCatalogSelected] = useState('')
	const [loading, setLoading] = useState(false)
	const [errorSteps, setErrorSteps] = useState(typeCatalogSelected.length === 0 || nameCatalog.length === 0)
	const [cadenasAuthorized, setCadenasAuthorized] = useState(JSON.parse(localStorage.getItem('user_data')).user_data.cadenas)
	const [loadingCreate, setLoadingCreate] = useState(false)
	const navigate = useNavigate()

	console.log("INFO DE CADENAS AUTORIZADAS:::::: ")
	console.log(JSON.parse(localStorage.getItem('user_data')).user_data.cadenas)

	console.log("Cadenas parseadas.::: ")
	console.log(cadenasAuthorized)

	useEffect(() => {
		;(async () => {
			try {
				setLoading(true)
				const {data} = await createCatalog()
				if (data) {
					setGrocers(data)
					// Convertir grocers en un mapa por id_cadena para acceso rápido
					const grocerMap = {};
					data.forEach(g => {
						grocerMap[g.id_cadena] = g;
					});

					// Combinar los datos
					const result = cadenasAuthorized.map(cadena => {
						const datosExtra = grocerMap[cadena.id] || {};
						return {
							...cadena,
							margen_comercial_porcentual: datosExtra.margen_comercial_porcentual || null,
							roi_historico_cadena: datosExtra.roi_historico_cadena || null
						};
					});
					setCadenasAuthorized(result)
					setLoading(false)
				}
			} catch (error) {
				console.log(error)
			} finally {
				setLoading(false)
			}
		})()
	}, [])

	useEffect(() => {
		const isError = typeCatalogSelected.length === 0 || nameCatalog.length === 0
		setErrorSteps(isError)
	}, [typeCatalogSelected, nameCatalog])

	const handleChangeTipoCatalogo = (event) => {
		setTypeCatalogSelected(event.target.value)
		if(event.target.value !== '0'){
			setwarning(null)
		}else{
			setwarning('Debes seleccionar un tipo de catalogo')
		}
	}

	const handleBtnCreateCatalog = async (e) => {
		if (step === 3) {
			try {
				setLoadingCreate(true)
				setLoading(true)
				const {data} = await createNewCatalogs([
					{
						tipo_promocion: parseInt(typeCatalogSelected),
						descripcion: '',
						nombre_promo: nameCatalog,
						id_cadena: grocersSelected?.id_cadena,
					},
				])
				if (data) {
					navigate(`/catalogo/${data[0].inserted_promotion_id}/1`)
					setLoadingCreate(false)
					setLoading(false)
				}
			} catch (error) {
				navigate(`/HomeNew`)
			} finally {
				setLoadingCreate(false)
				setLoading(false)
			}
		}
		if (step === 1) {
			if (tag === true) {
				setslidingValue(831)
				setStep(step + 1)
				setwarning(null)
			} else {
				setwarning('Debes seleccionar una cadena para poder continuar')
			}
		} else if (step === 2 ) {
			if (!errorSteps && (typeCatalogSelected !== "0" && nameCatalog.length > 0)) {
				// alert(typeCatalogSelected);
				setslidingValue(slidingValue + 831)
				setStep(step + 1)
				setwarning(null)
			} else {
				setwarning('Debes definir un nombre y tipo para poder continuar')
			}
		}
	}

	return (
		<>
			{loadingCreate && <LoaderNew notdo={true}/>}
			<span
				className='black_bg'
				// onClick={(e) => setCreateCatalogState(false)}
			></span>
			<div className='CreateCatalog'>
				<div className='top_area'>
					<div
						className='line'
						style={{width: `${step === 1 ? 150 : step === 2 ? 400 : 700}px`}}
					></div>
					<h1></h1>
					<div className='steps_area'>
						<div
							className='stepbox'
							onClick={(e) => {
								setslidingValue(0)
								setStep(1)
							}}
						>
							{step === 1 && (
								<svg
									width='49'
									height='48'
									viewBox='0 0 49 48'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g filter='url(#filter0_d_177_905601)'>
										<g clipPath='url(#clip0_177_905601)'>
											<rect
												x='4.66663'
												y='4'
												width='40'
												height='40'
												rx='20'
												fill='white'
											/>
											<path
												d='M21.3446 30.644C20.3606 30.644 19.4786 30.392 18.6986 29.888C17.9306 29.384 17.3186 28.652 16.8626 27.692C16.4186 26.732 16.1966 25.568 16.1966 24.2C16.1966 22.832 16.4186 21.668 16.8626 20.708C17.3186 19.748 17.9306 19.016 18.6986 18.512C19.4786 18.008 20.3606 17.756 21.3446 17.756C22.3166 17.756 23.1926 18.008 23.9726 18.512C24.7526 19.016 25.3646 19.748 25.8086 20.708C26.2526 21.668 26.4746 22.832 26.4746 24.2C26.4746 25.568 26.2526 26.732 25.8086 27.692C25.3646 28.652 24.7526 29.384 23.9726 29.888C23.1926 30.392 22.3166 30.644 21.3446 30.644ZM21.3446 29.042C22.0046 29.042 22.5806 28.862 23.0726 28.502C23.5766 28.142 23.9666 27.602 24.2426 26.882C24.5306 26.162 24.6746 25.268 24.6746 24.2C24.6746 23.132 24.5306 22.238 24.2426 21.518C23.9666 20.798 23.5766 20.258 23.0726 19.898C22.5806 19.538 22.0046 19.358 21.3446 19.358C20.6846 19.358 20.1026 19.538 19.5986 19.898C19.0946 20.258 18.6986 20.798 18.4106 21.518C18.1346 22.238 17.9966 23.132 17.9966 24.2C17.9966 25.268 18.1346 26.162 18.4106 26.882C18.6986 27.602 19.0946 28.142 19.5986 28.502C20.1026 28.862 20.6846 29.042 21.3446 29.042ZM30.3265 30.5V18.62L31.1005 19.466H27.4825V17.9H32.1085V30.5H30.3265Z'
												fill='#3676F5'
											/>
										</g>
										<rect
											x='4.66663'
											y='4'
											width='40'
											height='40'
											rx='20'
											stroke='#3676F5'
											strokeWidth='2'
										/>
									</g>
									<defs>
										<filter
											id='filter0_d_177_905601'
											x='0.666626'
											y='0'
											width='48'
											height='48'
											filterUnits='userSpaceOnUse'
											colorInterpolationFilters='sRGB'
										>
											<feFlood floodOpacity='0' result='BackgroundImageFix' />
											<feColorMatrix
												in='SourceAlpha'
												type='matrix'
												values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
												result='hardAlpha'
											/>
											<feMorphology
												radius='3'
												operator='dilate'
												in='SourceAlpha'
												result='effect1_dropShadow_177_905601'
											/>
											<feOffset />
											<feComposite in2='hardAlpha' operator='out' />
											<feColorMatrix
												type='matrix'
												values='0 0 0 0 0.858333 0 0 0 0 0.905556 0 0 0 0 1 0 0 0 1 0'
											/>
											<feBlend
												mode='normal'
												in2='BackgroundImageFix'
												result='effect1_dropShadow_177_905601'
											/>
											<feBlend
												mode='normal'
												in='SourceGraphic'
												in2='effect1_dropShadow_177_905601'
												result='shape'
											/>
										</filter>
										<clipPath id='clip0_177_905601'>
											<rect
												x='4.66663'
												y='4'
												width='40'
												height='40'
												rx='20'
												fill='white'
											/>
										</clipPath>
									</defs>
								</svg>
							)}

							{(step === 2 || step === 3) && (
								<svg
									width='43'
									height='42'
									viewBox='0 0 43 42'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g clipPath='url(#clip0_177_507878)'>
										<rect
											x='1.66663'
											y='1'
											width='40'
											height='40'
											rx='20'
											fill='#3676F5'
										/>
										<path
											d='M18.3446 27.644C17.3606 27.644 16.4786 27.392 15.6986 26.888C14.9306 26.384 14.3186 25.652 13.8626 24.692C13.4186 23.732 13.1966 22.568 13.1966 21.2C13.1966 19.832 13.4186 18.668 13.8626 17.708C14.3186 16.748 14.9306 16.016 15.6986 15.512C16.4786 15.008 17.3606 14.756 18.3446 14.756C19.3166 14.756 20.1926 15.008 20.9726 15.512C21.7526 16.016 22.3646 16.748 22.8086 17.708C23.2526 18.668 23.4746 19.832 23.4746 21.2C23.4746 22.568 23.2526 23.732 22.8086 24.692C22.3646 25.652 21.7526 26.384 20.9726 26.888C20.1926 27.392 19.3166 27.644 18.3446 27.644ZM18.3446 26.042C19.0046 26.042 19.5806 25.862 20.0726 25.502C20.5766 25.142 20.9666 24.602 21.2426 23.882C21.5306 23.162 21.6746 22.268 21.6746 21.2C21.6746 20.132 21.5306 19.238 21.2426 18.518C20.9666 17.798 20.5766 17.258 20.0726 16.898C19.5806 16.538 19.0046 16.358 18.3446 16.358C17.6846 16.358 17.1026 16.538 16.5986 16.898C16.0946 17.258 15.6986 17.798 15.4106 18.518C15.1346 19.238 14.9966 20.132 14.9966 21.2C14.9966 22.268 15.1346 23.162 15.4106 23.882C15.6986 24.602 16.0946 25.142 16.5986 25.502C17.1026 25.862 17.6846 26.042 18.3446 26.042ZM27.3265 27.5V15.62L28.1005 16.466H24.4825V14.9H29.1085V27.5H27.3265Z'
											fill='white'
										/>
									</g>
									<rect
										x='1.66663'
										y='1'
										width='40'
										height='40'
										rx='20'
										stroke='#3676F5'
										strokeWidth='2'
									/>
									<defs>
										<clipPath id='clip0_177_507878'>
											<rect
												x='1.66663'
												y='1'
												width='40'
												height='40'
												rx='20'
												fill='white'
											/>
										</clipPath>
									</defs>
								</svg>
							)}

							<h1>Elige una Cadena</h1>
						</div>

						<div
							className='stepbox'
							onClick={(e) => {
								if (tag === true) {
									setStep(2)
									setslidingValue(831)
									setwarning(null)
								} else {
									setwarning(
										'Debes seleccionar una cadena para poder continuar'
									)
								}
							}}
						>
							{step === 2 && (
								<svg
									width='48'
									height='48'
									viewBox='0 0 48 48'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g filter='url(#filter0_d_177_909155)'>
										<g clipPath='url(#clip0_177_909155)'>
											<rect
												x='4'
												y='4'
												width='40'
												height='40'
												rx='20'
												fill='white'
											/>
											<path
												d='M18.8411 30.644C17.8571 30.644 16.9751 30.392 16.1951 29.888C15.4271 29.384 14.8151 28.652 14.3591 27.692C13.9151 26.732 13.6931 25.568 13.6931 24.2C13.6931 22.832 13.9151 21.668 14.3591 20.708C14.8151 19.748 15.4271 19.016 16.1951 18.512C16.9751 18.008 17.8571 17.756 18.8411 17.756C19.8131 17.756 20.6891 18.008 21.4691 18.512C22.2491 19.016 22.8611 19.748 23.3051 20.708C23.7491 21.668 23.9711 22.832 23.9711 24.2C23.9711 25.568 23.7491 26.732 23.3051 27.692C22.8611 28.652 22.2491 29.384 21.4691 29.888C20.6891 30.392 19.8131 30.644 18.8411 30.644ZM18.8411 29.042C19.5011 29.042 20.0771 28.862 20.5691 28.502C21.0731 28.142 21.4631 27.602 21.7391 26.882C22.0271 26.162 22.1711 25.268 22.1711 24.2C22.1711 23.132 22.0271 22.238 21.7391 21.518C21.4631 20.798 21.0731 20.258 20.5691 19.898C20.0771 19.538 19.5011 19.358 18.8411 19.358C18.1811 19.358 17.5991 19.538 17.0951 19.898C16.5911 20.258 16.1951 20.798 15.9071 21.518C15.6311 22.238 15.4931 23.132 15.4931 24.2C15.4931 25.268 15.6311 26.162 15.9071 26.882C16.1951 27.602 16.5911 28.142 17.0951 28.502C17.5991 28.862 18.1811 29.042 18.8411 29.042ZM25.501 30.5V29.276L30.631 24.326C31.087 23.894 31.423 23.516 31.639 23.192C31.867 22.856 32.017 22.55 32.089 22.274C32.173 21.986 32.215 21.71 32.215 21.446C32.215 20.798 31.987 20.288 31.531 19.916C31.075 19.544 30.409 19.358 29.533 19.358C28.861 19.358 28.255 19.472 27.715 19.7C27.175 19.916 26.707 20.258 26.311 20.726L25.087 19.664C25.567 19.052 26.209 18.584 27.013 18.26C27.829 17.924 28.723 17.756 29.695 17.756C30.571 17.756 31.333 17.9 31.981 18.188C32.629 18.464 33.127 18.866 33.475 19.394C33.835 19.922 34.015 20.546 34.015 21.266C34.015 21.674 33.961 22.076 33.853 22.472C33.745 22.868 33.541 23.288 33.241 23.732C32.941 24.176 32.509 24.674 31.945 25.226L27.373 29.636L26.941 28.934H34.555V30.5H25.501Z'
												fill='#3676F5'
											/>
										</g>
										<rect
											x='4'
											y='4'
											width='40'
											height='40'
											rx='20'
											stroke='#3676F5'
											strokeWidth='2'
										/>
									</g>
									<defs>
										<filter
											id='filter0_d_177_909155'
											x='0'
											y='0'
											width='48'
											height='48'
											filterUnits='userSpaceOnUse'
											colorInterpolationFilters='sRGB'
										>
											<feFlood floodOpacity='0' result='BackgroundImageFix' />
											<feColorMatrix
												in='SourceAlpha'
												type='matrix'
												values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
												result='hardAlpha'
											/>
											<feMorphology
												radius='3'
												operator='dilate'
												in='SourceAlpha'
												result='effect1_dropShadow_177_909155'
											/>
											<feOffset />
											<feComposite in2='hardAlpha' operator='out' />
											<feColorMatrix
												type='matrix'
												values='0 0 0 0 0.858333 0 0 0 0 0.905556 0 0 0 0 1 0 0 0 1 0'
											/>
											<feBlend
												mode='normal'
												in2='BackgroundImageFix'
												result='effect1_dropShadow_177_909155'
											/>
											<feBlend
												mode='normal'
												in='SourceGraphic'
												in2='effect1_dropShadow_177_909155'
												result='shape'
											/>
										</filter>
										<clipPath id='clip0_177_909155'>
											<rect
												x='4'
												y='4'
												width='40'
												height='40'
												rx='20'
												fill='white'
											/>
										</clipPath>
									</defs>
								</svg>
							)}

							{step === 3 && (
								<svg
									width='42'
									height='42'
									viewBox='0 0 42 42'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g clipPath='url(#clip0_177_911643)'>
										<rect
											x='1'
											y='1'
											width='40'
											height='40'
											rx='20'
											fill='#3676F5'
										/>
										<path
											d='M15.8411 27.644C14.8571 27.644 13.9751 27.392 13.1951 26.888C12.4271 26.384 11.8151 25.652 11.3591 24.692C10.9151 23.732 10.6931 22.568 10.6931 21.2C10.6931 19.832 10.9151 18.668 11.3591 17.708C11.8151 16.748 12.4271 16.016 13.1951 15.512C13.9751 15.008 14.8571 14.756 15.8411 14.756C16.8131 14.756 17.6891 15.008 18.4691 15.512C19.2491 16.016 19.8611 16.748 20.3051 17.708C20.7491 18.668 20.9711 19.832 20.9711 21.2C20.9711 22.568 20.7491 23.732 20.3051 24.692C19.8611 25.652 19.2491 26.384 18.4691 26.888C17.6891 27.392 16.8131 27.644 15.8411 27.644ZM15.8411 26.042C16.5011 26.042 17.0771 25.862 17.5691 25.502C18.0731 25.142 18.4631 24.602 18.7391 23.882C19.0271 23.162 19.1711 22.268 19.1711 21.2C19.1711 20.132 19.0271 19.238 18.7391 18.518C18.4631 17.798 18.0731 17.258 17.5691 16.898C17.0771 16.538 16.5011 16.358 15.8411 16.358C15.1811 16.358 14.5991 16.538 14.0951 16.898C13.5911 17.258 13.1951 17.798 12.9071 18.518C12.6311 19.238 12.4931 20.132 12.4931 21.2C12.4931 22.268 12.6311 23.162 12.9071 23.882C13.1951 24.602 13.5911 25.142 14.0951 25.502C14.5991 25.862 15.1811 26.042 15.8411 26.042ZM22.501 27.5V26.276L27.631 21.326C28.087 20.894 28.423 20.516 28.639 20.192C28.867 19.856 29.017 19.55 29.089 19.274C29.173 18.986 29.215 18.71 29.215 18.446C29.215 17.798 28.987 17.288 28.531 16.916C28.075 16.544 27.409 16.358 26.533 16.358C25.861 16.358 25.255 16.472 24.715 16.7C24.175 16.916 23.707 17.258 23.311 17.726L22.087 16.664C22.567 16.052 23.209 15.584 24.013 15.26C24.829 14.924 25.723 14.756 26.695 14.756C27.571 14.756 28.333 14.9 28.981 15.188C29.629 15.464 30.127 15.866 30.475 16.394C30.835 16.922 31.015 17.546 31.015 18.266C31.015 18.674 30.961 19.076 30.853 19.472C30.745 19.868 30.541 20.288 30.241 20.732C29.941 21.176 29.509 21.674 28.945 22.226L24.373 26.636L23.941 25.934H31.555V27.5H22.501Z'
											fill='white'
										/>
									</g>
									<rect
										x='1'
										y='1'
										width='40'
										height='40'
										rx='20'
										stroke='#3676F5'
										strokeWidth='2'
									/>
									<defs>
										<clipPath id='clip0_177_911643'>
											<rect
												x='1'
												y='1'
												width='40'
												height='40'
												rx='20'
												fill='white'
											/>
										</clipPath>
									</defs>
								</svg>
							)}

							{step === 1 && (
								<svg
									width='42'
									height='42'
									viewBox='0 0 42 42'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g clipPath='url(#clip0_177_448645)'>
										<rect
											x='1'
											y='1'
											width='40'
											height='40'
											rx='20'
											fill='white'
										/>
										<path
											d='M15.3411 27.144C14.3571 27.144 13.4751 26.892 12.6951 26.388C11.9271 25.884 11.3151 25.152 10.8591 24.192C10.4151 23.232 10.1931 22.068 10.1931 20.7C10.1931 19.332 10.4151 18.168 10.8591 17.208C11.3151 16.248 11.9271 15.516 12.6951 15.012C13.4751 14.508 14.3571 14.256 15.3411 14.256C16.3131 14.256 17.1891 14.508 17.9691 15.012C18.7491 15.516 19.3611 16.248 19.8051 17.208C20.2491 18.168 20.4711 19.332 20.4711 20.7C20.4711 22.068 20.2491 23.232 19.8051 24.192C19.3611 25.152 18.7491 25.884 17.9691 26.388C17.1891 26.892 16.3131 27.144 15.3411 27.144ZM15.3411 25.542C16.0011 25.542 16.5771 25.362 17.0691 25.002C17.5731 24.642 17.9631 24.102 18.2391 23.382C18.5271 22.662 18.6711 21.768 18.6711 20.7C18.6711 19.632 18.5271 18.738 18.2391 18.018C17.9631 17.298 17.5731 16.758 17.0691 16.398C16.5771 16.038 16.0011 15.858 15.3411 15.858C14.6811 15.858 14.0991 16.038 13.5951 16.398C13.0911 16.758 12.6951 17.298 12.4071 18.018C12.1311 18.738 11.9931 19.632 11.9931 20.7C11.9931 21.768 12.1311 22.662 12.4071 23.382C12.6951 24.102 13.0911 24.642 13.5951 25.002C14.0991 25.362 14.6811 25.542 15.3411 25.542ZM22.001 27V25.776L27.131 20.826C27.587 20.394 27.923 20.016 28.139 19.692C28.367 19.356 28.517 19.05 28.589 18.774C28.673 18.486 28.715 18.21 28.715 17.946C28.715 17.298 28.487 16.788 28.031 16.416C27.575 16.044 26.909 15.858 26.033 15.858C25.361 15.858 24.755 15.972 24.215 16.2C23.675 16.416 23.207 16.758 22.811 17.226L21.587 16.164C22.067 15.552 22.709 15.084 23.513 14.76C24.329 14.424 25.223 14.256 26.195 14.256C27.071 14.256 27.833 14.4 28.481 14.688C29.129 14.964 29.627 15.366 29.975 15.894C30.335 16.422 30.515 17.046 30.515 17.766C30.515 18.174 30.461 18.576 30.353 18.972C30.245 19.368 30.041 19.788 29.741 20.232C29.441 20.676 29.009 21.174 28.445 21.726L23.873 26.136L23.441 25.434H31.055V27H22.001Z'
											fill='#C7C7C7'
										/>
									</g>
									<rect
										x='1'
										y='1'
										width='40'
										height='40'
										rx='20'
										stroke='#E0E0E0'
										strokeWidth='2'
									/>
									<defs>
										<clipPath id='clip0_177_448645'>
											<rect
												x='1'
												y='1'
												width='40'
												height='40'
												rx='20'
												fill='white'
											/>
										</clipPath>
									</defs>
								</svg>
							)}

							<h1>Define un nombre</h1>
						</div>

						<div
							className='stepbox'
							onClick={(e) => {
								if (nameCatalog.length > 0) {
									setslidingValue(831 + 831)
									setStep(3)
									setwarning(null)
								} else {
									setwarning('Debes definir un nombre para poder continuar')
								}
							}}
						>
							{step === 3 && (
								<svg
									width='49'
									height='48'
									viewBox='0 0 49 48'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g filter='url(#filter0_d_177_508195)'>
										<g clipPath='url(#clip0_177_508195)'>
											<rect
												x='4.33337'
												y='4'
												width='40'
												height='40'
												rx='20'
												fill='white'
											/>
											<path
												d='M19.2799 30.644C18.2959 30.644 17.4139 30.392 16.6339 29.888C15.8659 29.384 15.2539 28.652 14.7979 27.692C14.3539 26.732 14.1319 25.568 14.1319 24.2C14.1319 22.832 14.3539 21.668 14.7979 20.708C15.2539 19.748 15.8659 19.016 16.6339 18.512C17.4139 18.008 18.2959 17.756 19.2799 17.756C20.2519 17.756 21.1279 18.008 21.9079 18.512C22.6879 19.016 23.2999 19.748 23.7439 20.708C24.1879 21.668 24.4099 22.832 24.4099 24.2C24.4099 25.568 24.1879 26.732 23.7439 27.692C23.2999 28.652 22.6879 29.384 21.9079 29.888C21.1279 30.392 20.2519 30.644 19.2799 30.644ZM19.2799 29.042C19.9399 29.042 20.5159 28.862 21.0079 28.502C21.5119 28.142 21.9019 27.602 22.1779 26.882C22.4659 26.162 22.6099 25.268 22.6099 24.2C22.6099 23.132 22.4659 22.238 22.1779 21.518C21.9019 20.798 21.5119 20.258 21.0079 19.898C20.5159 19.538 19.9399 19.358 19.2799 19.358C18.6199 19.358 18.0379 19.538 17.5339 19.898C17.0299 20.258 16.6339 20.798 16.3459 21.518C16.0699 22.238 15.9319 23.132 15.9319 24.2C15.9319 25.268 16.0699 26.162 16.3459 26.882C16.6339 27.602 17.0299 28.142 17.5339 28.502C18.0379 28.862 18.6199 29.042 19.2799 29.042ZM29.814 30.644C28.926 30.644 28.062 30.506 27.222 30.23C26.394 29.954 25.716 29.582 25.188 29.114L26.016 27.692C26.436 28.088 26.982 28.412 27.654 28.664C28.326 28.916 29.046 29.042 29.814 29.042C30.75 29.042 31.476 28.844 31.992 28.448C32.52 28.04 32.784 27.494 32.784 26.81C32.784 26.15 32.532 25.622 32.028 25.226C31.536 24.818 30.75 24.614 29.67 24.614H28.662V23.354L32.406 18.746L32.658 19.466H25.764V17.9H34.08V19.124L30.354 23.714L29.418 23.156H30.012C31.536 23.156 32.676 23.498 33.432 24.182C34.2 24.866 34.584 25.736 34.584 26.792C34.584 27.5 34.41 28.148 34.062 28.736C33.714 29.324 33.186 29.792 32.478 30.14C31.782 30.476 30.894 30.644 29.814 30.644Z'
												fill='#3676F5'
											/>
										</g>
										<rect
											x='4.33337'
											y='4'
											width='40'
											height='40'
											rx='20'
											stroke='#3676F5'
											strokeWidth='2'
										/>
									</g>
									<defs>
										<filter
											id='filter0_d_177_508195'
											x='0.333374'
											y='0'
											width='48'
											height='48'
											filterUnits='userSpaceOnUse'
											colorInterpolationFilters='sRGB'
										>
											<feFlood floodOpacity='0' result='BackgroundImageFix' />
											<feColorMatrix
												in='SourceAlpha'
												type='matrix'
												values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
												result='hardAlpha'
											/>
											<feMorphology
												radius='3'
												operator='dilate'
												in='SourceAlpha'
												result='effect1_dropShadow_177_508195'
											/>
											<feOffset />
											<feComposite in2='hardAlpha' operator='out' />
											<feColorMatrix
												type='matrix'
												values='0 0 0 0 0.858333 0 0 0 0 0.905556 0 0 0 0 1 0 0 0 1 0'
											/>
											<feBlend
												mode='normal'
												in2='BackgroundImageFix'
												result='effect1_dropShadow_177_508195'
											/>
											<feBlend
												mode='normal'
												in='SourceGraphic'
												in2='effect1_dropShadow_177_508195'
												result='shape'
											/>
										</filter>
										<clipPath id='clip0_177_508195'>
											<rect
												x='4.33337'
												y='4'
												width='40'
												height='40'
												rx='20'
												fill='white'
											/>
										</clipPath>
									</defs>
								</svg>
							)}
							{step !== 3 && (
								<svg
									width='43'
									height='42'
									viewBox='0 0 43 42'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g clipPath='url(#clip0_177_906339)'>
										<rect
											x='1.33337'
											y='1'
											width='40'
											height='40'
											rx='20'
											fill='white'
										/>
										<path
											d='M15.7799 27.144C14.7959 27.144 13.9139 26.892 13.1339 26.388C12.3659 25.884 11.7539 25.152 11.2979 24.192C10.8539 23.232 10.6319 22.068 10.6319 20.7C10.6319 19.332 10.8539 18.168 11.2979 17.208C11.7539 16.248 12.3659 15.516 13.1339 15.012C13.9139 14.508 14.7959 14.256 15.7799 14.256C16.7519 14.256 17.6279 14.508 18.4079 15.012C19.1879 15.516 19.7999 16.248 20.2439 17.208C20.6879 18.168 20.9099 19.332 20.9099 20.7C20.9099 22.068 20.6879 23.232 20.2439 24.192C19.7999 25.152 19.1879 25.884 18.4079 26.388C17.6279 26.892 16.7519 27.144 15.7799 27.144ZM15.7799 25.542C16.4399 25.542 17.0159 25.362 17.5079 25.002C18.0119 24.642 18.4019 24.102 18.6779 23.382C18.9659 22.662 19.1099 21.768 19.1099 20.7C19.1099 19.632 18.9659 18.738 18.6779 18.018C18.4019 17.298 18.0119 16.758 17.5079 16.398C17.0159 16.038 16.4399 15.858 15.7799 15.858C15.1199 15.858 14.5379 16.038 14.0339 16.398C13.5299 16.758 13.1339 17.298 12.8459 18.018C12.5699 18.738 12.4319 19.632 12.4319 20.7C12.4319 21.768 12.5699 22.662 12.8459 23.382C13.1339 24.102 13.5299 24.642 14.0339 25.002C14.5379 25.362 15.1199 25.542 15.7799 25.542ZM26.314 27.144C25.426 27.144 24.562 27.006 23.722 26.73C22.894 26.454 22.216 26.082 21.688 25.614L22.516 24.192C22.936 24.588 23.482 24.912 24.154 25.164C24.826 25.416 25.546 25.542 26.314 25.542C27.25 25.542 27.976 25.344 28.492 24.948C29.02 24.54 29.284 23.994 29.284 23.31C29.284 22.65 29.032 22.122 28.528 21.726C28.036 21.318 27.25 21.114 26.17 21.114H25.162V19.854L28.906 15.246L29.158 15.966H22.264V14.4H30.58V15.624L26.854 20.214L25.918 19.656H26.512C28.036 19.656 29.176 19.998 29.932 20.682C30.7 21.366 31.084 22.236 31.084 23.292C31.084 24 30.91 24.648 30.562 25.236C30.214 25.824 29.686 26.292 28.978 26.64C28.282 26.976 27.394 27.144 26.314 27.144Z'
											fill='#C7C7C7'
										/>
									</g>
									<rect
										x='1.33337'
										y='1'
										width='40'
										height='40'
										rx='20'
										stroke='#E0E0E0'
										strokeWidth='2'
									/>
									<defs>
										<clipPath id='clip0_177_906339'>
											<rect
												x='1.33337'
												y='1'
												width='40'
												height='40'
												rx='20'
												fill='white'
											/>
										</clipPath>
									</defs>
								</svg>
							)}
							<h1>Finalizar</h1>
						</div>
					</div>
				</div>

				<div className='body_area'>
					<div
						className='slider-area'
						style={{transform: `translateX(-${slidingValue}px)`}}
					>
						<div className='first_step'>
							{ // <h1>Elige una Cadena para empezar a crear tu promoción</h1>
								}
							<div className='grid_checkbox'>
								{loading ? (
									<Spinner />
								) : (
									grocers?.map((grocers) => {
										const autorizacion = cadenasAuthorized.find(cadena => cadena.id === grocers.id_cadena)
										if(!autorizacion){
											return false
										}
										return (
											<CheckboxStepPicture
												key={grocers.id_cadena}
												brand={getGrocersBrand(
													grocers.nombre_cadena
												)}
												settag={settag}
												setwarning={setwarning}
												grocers={grocers}
												checked={
													grocers?.id_cadena === grocersSelected?.id_cadena
												}
												setCadenaSeleccionada={setGrocersSelected}
											/>
										)
									})
								)}
							</div>
						</div>
						<div className='first_step second_step'>
							<div className='input_wrapper'>
								<label htmlFor='Nombre'>Nombre</label>
								<input
									type='text'
									className={nameCatalog.length > 0 && 'active'}
									placeholder='Ingrese nombre'
									value={nameCatalog}
									maxLength={30}
									onChange={(e) => {
										setwarning(null)
										setNameCatalog(e.target.value)
									}}
								/>
							</div>
							<div
								className='select_area'
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<label htmlFor=''>Tipo de catálogo</label>
								<select
									name=''
									id=''
									value={typeCatalogSelected}
									onChange={handleChangeTipoCatalogo}
								>
									<option value='0'>Selecciona un formato</option>
									<option value='1'>SELL-IN</option>
									<option value='2'>SELL-OUT</option>
								</select>
							</div>
							{/* <div className='input_wrapper'>
								<label htmlFor='Descripción'>Descripción</label>
								<textarea
									value={desc}
									cols='30'
									className={desc.length > 0 && 'active'}
									rows='10'
									onChange={(e) => {
										setwarning(null)
										setdesc(e.target.value)
									}}
									placeholder='Lorem Ipsum Dolor'
								></textarea>
								{desc.length > 0 && (
									<svg
										className='text-area-done ok-sign'
										width='12'
										height='12'
										viewBox='0 0 12 12'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'
									>
										<path
											d='M11.5666 4.35C11.6444 4.60555 11.7028 4.87222 11.742 5.15C11.7806 5.42777 11.8 5.71111 11.8 6C11.8 6.8 11.6473 7.55266 11.342 8.258C11.0362 8.96377 10.6222 9.57778 10.1 10.1C9.57773 10.6222 8.96395 11.036 8.25862 11.3413C7.55284 11.6471 6.79995 11.8 5.99995 11.8C5.19995 11.8 4.44728 11.6471 3.74195 11.3413C3.03617 11.036 2.42217 10.6222 1.89995 10.1C1.37773 9.57778 0.963729 8.96377 0.657951 8.258C0.352618 7.55266 0.199951 6.8 0.199951 6C0.199951 5.2 0.352618 4.44711 0.657951 3.74133C0.963729 3.036 1.37773 2.42222 1.89995 1.9C2.42217 1.37777 3.03617 0.963775 3.74195 0.657997C4.44728 0.352664 5.19995 0.199997 5.99995 0.199997C6.63328 0.199997 7.23062 0.291552 7.79195 0.474664C8.35284 0.658219 8.86662 0.916664 9.33328 1.25C9.38884 1.29444 9.42217 1.34711 9.43328 1.408C9.4444 1.46933 9.42217 1.52777 9.36662 1.58333C9.32217 1.63889 9.26395 1.66666 9.19195 1.66666C9.11951 1.66666 9.05551 1.64444 8.99995 1.6C8.57773 1.3 8.11395 1.06933 7.60862 0.907997C7.10284 0.747108 6.56662 0.666664 5.99995 0.666664C4.52217 0.666664 3.26395 1.186 2.22528 2.22466C1.18617 3.26377 0.666618 4.52222 0.666618 6C0.666618 7.47777 1.18617 8.73622 2.22528 9.77533C3.26395 10.814 4.52217 11.3333 5.99995 11.3333C7.47773 11.3333 8.73617 10.814 9.77528 9.77533C10.814 8.73622 11.3333 7.47777 11.3333 6C11.3333 5.73333 11.314 5.47222 11.2753 5.21666C11.2362 4.96111 11.1777 4.71111 11.1 4.46666C11.0888 4.43333 11.0888 4.39444 11.1 4.35C11.1111 4.30555 11.1277 4.27222 11.15 4.25C11.2277 4.16111 11.3084 4.12777 11.392 4.15C11.4751 4.17222 11.5333 4.23889 11.5666 4.35ZM4.68328 8.11666L2.94995 6.38333C2.90551 6.33889 2.88617 6.286 2.89195 6.22466C2.89728 6.16377 2.92217 6.11111 2.96662 6.06666C3.02217 6.01111 3.07773 5.98333 3.13328 5.98333C3.18884 5.98333 3.2444 6.01111 3.29995 6.06666L5.03328 7.8L11.3166 1.51666C11.3611 1.47222 11.414 1.45289 11.4753 1.45866C11.5362 1.464 11.5888 1.48889 11.6333 1.53333C11.6888 1.58889 11.7166 1.64444 11.7166 1.7C11.7166 1.75555 11.6888 1.81111 11.6333 1.86666L5.38328 8.11666C5.28328 8.21666 5.16662 8.26666 5.03328 8.26666C4.89995 8.26666 4.78328 8.21666 4.68328 8.11666Z'
											fill='#3676F5'
										/>
									</svg>
								)}
								<span>Obligatorio *</span>
							</div> */}
						</div>
						<div className='first_step third_step'>
							<h1>Vas a crear la siguiente promoción</h1>
							<div className='third_grid'>
								<div className='grid_box'>
									<h1>Cadena</h1>
									<div className='tag_grid'>
										{grocersSelected && (
											(() => {
												const brand = getGrocersBrand(grocersSelected?.nombre_cadena)
												return (
													<span
														className='brand_label_mini'
														style={{
															backgroundColor: brand.bg,
															color: '#FFFFFF',
														}}
													>
														{brand.label}
													</span>
												)
											})()
										)}
									</div>
								</div>
								<div className='grid_box'>
									
									<h1>ROI Histórico</h1>
									<p>{grocersSelected?.roi_historico_cadena}</p>
									{/*
									<h1>Mg. Comercial %</h1>
									<p>{grocersSelected?.margen_comercial_porcentual}</p>
									*/}
								</div>
								<div className='grid_box'>
									<h1>Nombre</h1>
									<p>{nameCatalog}</p>
								</div>
								<div className='grid_box'>
									<h1>Tipo</h1>
									<p>{TYPE_CATALOG[typeCatalogSelected] || '-'}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				{step !== 3 && (
					<>
						{!warning && (
							<div className='bottom_body_area'>
								<div className='bottom_box'>
									<h1>Cadena</h1>
									<div className='tag_inner'>
										{grocersSelected ? (
											(() => {
												const brand = getGrocersBrand(grocersSelected?.nombre_cadena)
												return (
													<span
														className='brand_label_mini'
														style={{
															backgroundColor: brand.bg,
															color: '#FFFFFF',
														}}
													>
														{brand.label}
													</span>
												)
											})()
										) : (
											<span className='tag_placeholder'>Selecciona una cadena</span>
										)}
									</div>
								</div>
								<div className='bottom_box'>
									
									<h1>ROI Histórico</h1>
									<p>{grocersSelected?.roi_historico_cadena || '-'}</p>
									{/*
									<h1>Mg. Comercial %</h1>
									<p>{grocersSelected?.margen_comercial_porcentual}</p>
									*/}
								</div>
								<div className='bottom_box'>
									<h1>Nombre</h1>
									<p>{nameCatalog || '-'}</p>
								</div>
								<div className='bottom_box'>
									<h1>Tipo</h1>
									<p>{TYPE_CATALOG[typeCatalogSelected] || '-'}</p>
								</div>
							</div>
						)}
					</>
				)}

				{warning && (
					<div className=' bottom_body_area_warning_wrapper'>
						<div className='bottom_body_area bottom_body_area_warning'>
							<svg
								width='24'
								height='24'
								viewBox='0 0 24 24'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_177_464808'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='24'
									height='24'
								>
									<rect width='24' height='24' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_177_464808)'>
									<path
										d='M4.54766 19.7001C4.26432 19.7001 4.04766 19.5751 3.89766 19.3251C3.74766 19.0751 3.74766 18.8251 3.89766 18.5751L11.3477 5.7251C11.4977 5.4751 11.7143 5.3501 11.9977 5.3501C12.281 5.3501 12.4977 5.4751 12.6477 5.7251L20.0977 18.5751C20.2477 18.8251 20.2477 19.0751 20.0977 19.3251C19.9477 19.5751 19.731 19.7001 19.4477 19.7001H4.54766ZM11.9977 10.5001C11.8977 10.5001 11.8143 10.5334 11.7477 10.6001C11.681 10.6668 11.6477 10.7501 11.6477 10.8501V15.1501C11.6477 15.2501 11.681 15.3334 11.7477 15.4001C11.8143 15.4668 11.8977 15.5001 11.9977 15.5001C12.0977 15.5001 12.181 15.4668 12.2477 15.4001C12.3143 15.3334 12.3477 15.2501 12.3477 15.1501V10.8501C12.3477 10.7501 12.3143 10.6668 12.2477 10.6001C12.181 10.5334 12.0977 10.5001 11.9977 10.5001ZM11.9977 17.5001C12.1477 17.5001 12.2687 17.4501 12.3607 17.3501C12.452 17.2501 12.4977 17.1334 12.4977 17.0001C12.4977 16.8501 12.452 16.7291 12.3607 16.6371C12.2687 16.5458 12.1477 16.5001 11.9977 16.5001C11.8643 16.5001 11.7477 16.5458 11.6477 16.6371C11.5477 16.7291 11.4977 16.8501 11.4977 17.0001C11.4977 17.1334 11.5477 17.2501 11.6477 17.3501C11.7477 17.4501 11.8643 17.5001 11.9977 17.5001ZM4.44766 19.0001H19.5477L11.9977 6.0001L4.44766 19.0001Z'
										fill='#E67A00'
									/>
								</g>
							</svg>

							<p>{warning}</p>
						{/*	<svg
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_177_465136'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='16'
									height='16'
								>
									<rect width='16' height='16' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_177_465136)'>
									<path
										d='M7.99896 9.0666L4.79896 12.2666C4.65451 12.411 4.47674 12.4833 4.26562 12.4833C4.05451 12.4833 3.87674 12.411 3.73229 12.2666C3.58785 12.1222 3.51562 11.9444 3.51562 11.7333C3.51562 11.5222 3.58785 11.3444 3.73229 11.1999L6.93229 7.99994L3.73229 4.79993C3.58785 4.65549 3.51562 4.47771 3.51562 4.2666C3.51562 4.05549 3.58785 3.87771 3.73229 3.73327C3.87674 3.58882 4.05451 3.5166 4.26562 3.5166C4.47674 3.5166 4.65451 3.58882 4.79896 3.73327L7.99896 6.93327L11.199 3.73327C11.3434 3.58882 11.5212 3.5166 11.7323 3.5166C11.9434 3.5166 12.1212 3.58882 12.2656 3.73327C12.4101 3.87771 12.4823 4.05549 12.4823 4.2666C12.4823 4.47771 12.4101 4.65549 12.2656 4.79993L9.06563 7.99994L12.2656 11.1999C12.4101 11.3444 12.4823 11.5222 12.4823 11.7333C12.4823 11.9444 12.4101 12.1222 12.2656 12.2666C12.1212 12.411 11.9434 12.4833 11.7323 12.4833C11.5212 12.4833 11.3434 12.411 11.199 12.2666L7.99896 9.0666Z'
										fill='#E67A00'
									/>
								</g>
							</svg>
						*/}
						</div>
					</div>
				)}

				<div className='bottom_area'>
					<button
						onClick={(e) => {
							setCreateCatalogState(false)
						}}
					>
						Cancelar
					</button>
					<div className='right_button_wrapper'>
						{step > 1 && (
							<button
								className='Anterior'
								onClick={(e) => {
									setStep(step - 1)
									setslidingValue(slidingValue - 831)
									setwarning(null)
								}}
							>
								<svg
									width='16'
									height='16'
									viewBox='0 0 16 16'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_177_909986'
										maskUnits='userSpaceOnUse'
										x='2'
										y='2'
										width='12'
										height='12'
									>
										<rect x='2' y='2' width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_177_909986)'>
										<path
											d='M9.375 12.5375L5.1625 8.3375C5.10417 8.27917 5.0625 8.21667 5.0375 8.15C5.0125 8.08333 5 8.0125 5 7.9375C5 7.8625 5.0125 7.79167 5.0375 7.725C5.0625 7.65833 5.10417 7.59583 5.1625 7.5375L9.375 3.325C9.50833 3.19167 9.67083 3.125 9.8625 3.125C10.0542 3.125 10.2167 3.19583 10.35 3.3375C10.4917 3.47083 10.5625 3.63117 10.5625 3.8185C10.5625 4.00617 10.4917 4.17083 10.35 4.3125L6.725 7.9375L10.35 11.5625C10.4833 11.6958 10.55 11.8562 10.55 12.0435C10.55 12.2312 10.4833 12.3958 10.35 12.5375C10.2083 12.6708 10.0438 12.7375 9.8565 12.7375C9.66883 12.7375 9.50833 12.6708 9.375 12.5375Z'
											fill='#124FC9'
										/>
									</g>
								</svg>
								Anterior
							</button>
						)}
					{	!loadingCreate ?
						<button
							className='SiguienteBtn'
							onClick={handleBtnCreateCatalog}
							disabled={warning}
						>
							{step === 3 ? 'Crear' : 'Siguiente'}
							<svg
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_177_779623'
									maskUnits='userSpaceOnUse'
									x='2'
									y='2'
									width='12'
									height='12'
								>
									<rect x='2' y='2' width='12' height='12' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_177_779623)'>
									<path
										d='M5.52451 12.6C5.39118 12.4583 5.32451 12.2937 5.32451 12.106C5.32451 11.9187 5.39118 11.7542 5.52451 11.6125L9.13701 8L5.51201 4.375C5.37868 4.24167 5.31201 4.07917 5.31201 3.8875C5.31201 3.69583 5.38285 3.52917 5.52451 3.3875C5.65785 3.25417 5.82034 3.1875 6.01201 3.1875C6.20368 3.1875 6.37034 3.25417 6.51201 3.3875L10.712 7.6C10.7703 7.65833 10.812 7.72083 10.837 7.7875C10.862 7.85417 10.8745 7.925 10.8745 8C10.8745 8.075 10.862 8.14583 10.837 8.2125C10.812 8.27917 10.7703 8.34167 10.712 8.4L6.49951 12.6125C6.36618 12.7458 6.20568 12.8125 6.01801 12.8125C5.83068 12.8125 5.66618 12.7417 5.52451 12.6Z'
										fill='white'
									/>
								</g>
							</svg>
						</button>
						: <Spinner />
					}
					</div>
				</div>
			</div>
		</>
	)
}
